/**
 * Referral program tunables. Shared by the backend (dedupe, TTL,
 * attribution defaults), the embed script (cookie lifetime) and the
 * admin panel (form defaults). See `docs/referral.md`.
 */
export const REFERRAL_CONFIG = {
  /**
   * A repeat of the same `visitorId` + link + type + target inside this
   * window bumps `hits` on the existing `ReferralTracking` row instead of
   * inserting a new one. Keeps a page refresh from reading as ten views.
   */
  dedupeWindowMinutes: 30,
  /**
   * `ReferralTracking` rows expire after this many days (TTL index on
   * `doc.createdAt`). Hits older than a reward cycle are analytics only,
   * and `ReferralLink.stats` already holds the counts.
   */
  trackingTtlDays: 180,
  /**
   * Default `attribution.windowMinutes` on a new link — how far back a
   * hit may sit and still be matched to a lead that arrived with no code.
   * 72 hours (3 days): a flyer / WhatsApp click often converts overnight
   * or over a weekend. The admin form shows this as hours; the API and
   * DB stay in minutes.
   */
  defaultAttributionWindowMinutes: 72 * 60,
  /**
   * Hard ceiling on `attribution.windowMinutes` so a link cannot claim
   * every lead of the month. 7 days.
   */
  maxAttributionWindowMinutes: 7 * 24 * 60,
  /**
   * First-party cookie lifetime for `hero_r` (the code) and `hero_vid`
   * (the visitor id), in days.
   */
  cookieTtlDays: 90,
  /** Public tracking endpoint — requests per IP per minute before 429. */
  trackingRatePerMinute: 60,
  /**
   * Default length of a backend-generated code when the admin does not
   * pick one. See `REFERRAL_CODE_LENGTHS` in `@hero/schema`.
   */
  codeLength: 6,
} as const;
